import { getRequest } from '../services/requestHandler';
import { ShaftLengthDigit } from '../models';

export const getShaftLengthDigit = async () => {
  const url = 'shaftLengthdigit';
  const response = await getRequest<ShaftLengthDigit>('GetShaftLengthDigit', url);
  return response;
};
